export function toBoolString(value: boolean): "True" | "False" {
    return value ? "True" : "False";
}
